import { render } from "./DeleteSchemaForm.vue?vue&type=template&id=36e9f6f6"
import script from "./DeleteSchemaForm.vue?vue&type=script&lang=js"
export * from "./DeleteSchemaForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__